import { useSelector } from 'react-redux';
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { GetAddressAPI } from 'Services';
import { IAPI_ACTION, IDispatcherType, INITIAL_STATE } from 'types';
import Toasty from 'components/atoms/Toasty';

export const setAPIError = (state: ReturnType<typeof INITIAL_STATE>, action: IAPI_ACTION): void => {
	state.loading = false;
	state.error = action.error.message || 'Something went wrong';
	Toasty.error(state.error);
};

export const FetchAddressList = createAsyncThunk('get/fetchAddressList', GetAddressAPI);

export const FetchAddressListSlice = createSlice({
	name: 'fetchAddressList',
	initialState: INITIAL_STATE(),
	reducers: {
		CLEAR_ERROR: (state) => {
			state.error = '';
		},
		RESET: (state) => Object.assign(state, INITIAL_STATE()),
	},
	extraReducers: {
		[FetchAddressList.pending.toString()]: (state: ReturnType<typeof INITIAL_STATE>) => {
			state.data = {};
			state.error = '';
			state.loading = true;
			state.isFetched = false;
		},
		[FetchAddressList.rejected.toString()]: setAPIError,
		[FetchAddressList.fulfilled.toString()]: (state: ReturnType<typeof INITIAL_STATE>, action: IAPI_ACTION<any>) => {
			const { payload } = action;
			state.loading = false;
			state.isFetched = true;
			state.error = '';
			state.data = payload;
		},
	},
});

interface IStates {
	[FetchAddressListSlice.name]: ReturnType<typeof FetchAddressListSlice.reducer>;
}

export const fetchAddressListSelector = (state: IStates): any => {
	return state[FetchAddressListSlice.name] || {};
};

export const useFetchAddressList = (): any => useSelector(fetchAddressListSelector);

export const triggerAddressListApi =
	() =>
	async (dispatch: IDispatcherType): Promise<void> => {
		await dispatch(FetchAddressList());
		return;
	};

export const resetFetchAddressList =
	() =>
	async (dispatch: IDispatcherType): Promise<void> => {
		await dispatch(FetchAddressListSlice.actions.RESET());
		return;
	};
